// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__rbF1t","header":"ReportDetails_header__3A_5-","title":"ReportDetails_title__12Fgz","left":"ReportDetails_left__1JvvA"};